import type { LessonRecurringDay } from '../../model/lessons/interfaces'

import { getAxiosErrorMessage } from '@shared/api'
import { useAdminRoutes } from '@shared/lib/routes'
import { useToast } from '@shared/ui/toast'

interface LessonRecurringTrackApiOptions {
  disciplineId: string | number
  payload: {
    start_date: string
    days: LessonRecurringDay[]
    tutor_id: number
    availability: number
  }
}

/** `POST .../recurring-lessons/track` — leaves an audit comment when the chosen tutor is not fully available.
 *  Fire-and-forget: a failure is only shown, the recurring creation goes on. */
export const useLessonRecurringTrackApi = async (options: LessonRecurringTrackApiOptions): Promise<void> => {
  const { $axios } = useNuxtApp()
  const toast = useToast()

  const url = useAdminRoutes('admin.lessons.api.recurring-track', { discipline_id: options.disciplineId })
  if (!url) return

  try {
    await $axios.post(url, options.payload)
  } catch (err: unknown) {
    toast.error(getAxiosErrorMessage(err))
  }
}
